import {service} from '@/utils/request'
export default {
	//列表
	get(data) {
	  return service({
	    url: '/cloud/activity/admin/welfareActivity/page',
	    method: 'post',
	    data
	  })
	},
    // 添加
	save(data) {
	  return service({
	    url: '/cloud/activity/admin/welfareActivity/save',
	    method: 'post',
	    data
	  })
	},
    // 获取详情
	getDetail(id) {
	  return service({
	    url: '/cloud/activity/admin/welfareActivity/view/' + id,
	    method: 'get'
	  })
	},
    // 上下架
	switch(data) {
	  return service({
	    url: '/cloud/activity/admin/welfareActivity/opStatus',
	    method: 'post',
		data
	  })
	},
    // 删除
	delete(params) {
	  return service({
	    url: '/cloud/activity/admin/welfareActivity/remove',
	    method: 'post',
		params
	  })
	},
    // 用户
	user(id, data) {
	  return service({
	    url: '/cloud/activity/admin/welfareActivityReceive/search/searchByActivity/' + id,
	    method: 'post',
		data
	  })
	},
    // 发放
	shipped(id) {
	  return service({
	    url: '/cloud/activity/admin/welfareActivityReceive/shipped/' + id,
	    method: 'post'
	  })
	},
}


// WEBPACK FOOTER //
// ./src/api/operateManage/welfare.js